import * as XLSX from 'xlsx';

import { buildExportHeaderRows } from './header-rows';
import { type ExportHeaderInfo, type PortAssignmentExportData } from './types';

const TABLE_HEADERS = [
  'Name',
  'Target',
  'Target Port',
  'Source',
  'Source Port',
  'VLAN IDs',
  'PoE',
  'DHCP',
];

export const exportPortAssignmentsToLibreOffice = async (
  portAssignmentsData: PortAssignmentExportData[],
  filename: string,
  headerInfo?: ExportHeaderInfo,
) => {
  const data: any[] = [];

  if (headerInfo) {
    const headerRows = buildExportHeaderRows(headerInfo, TABLE_HEADERS.length);
    headerRows.forEach((row) => data.push(row));
  }

  data.push(TABLE_HEADERS);

  portAssignmentsData.forEach((item) => {
    data.push([
      item.Name,
      item.Target,
      item['Target Port'],
      item.Source,
      item['Source Port'],
      item.vlanIdsFormatted,
      item.poe,
      item.dhcp,
    ]);
  });

  const ws = XLSX.utils.aoa_to_sheet(data);
  ws['!merges'] = [];

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Report');

  XLSX.writeFile(wb, `${filename}.ods`, { bookType: 'ods', type: 'binary' });
};
